import { STEPS } from '../fields';

import { ConfigurationTitle, ConfigurationBody, ConfigurationFooter } from './configuration-step';

import { PreviewTitle, PreviewBody, PreviewFooter } from '../preview-step';

import { RecordingBody } from './recording-step';
import { RecordingTitle, RecordingFooter } from '../recording-step';

export const WIZZARD = {
  [STEPS.CONFIGURATION]: {
    Title: ConfigurationTitle,
    Body: ConfigurationBody,
    Footer: ConfigurationFooter,
  },
  [STEPS.RECORDING]: {
    Title: RecordingTitle,
    Body: RecordingBody,
    Footer: RecordingFooter,
  },
  [STEPS.PREVIEW]: {
    Title: PreviewTitle,
    Body: PreviewBody,
    Footer: PreviewFooter,
  },
};
